// src/utils/ExceptionContext.tsx
import React, { createContext, useContext, useState } from "react";

interface ExceptionContextType {
  isVisible: boolean;
  title: string;
  message: string;
  setException: (options: { title: string; message: string }) => void;
  clearException: () => void;
  isBannerVisible:()=>boolean;
}

const ExceptionContext = createContext<ExceptionContextType | undefined>(undefined);

export const ExceptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const setException = ({ title, message }: { title: string; message: string; }) => {
    setTitle(title);
    setMessage(message);
    setIsVisible(true);
  };

  const clearException = () => {
    setTitle("");
    setMessage("");
    setIsVisible(false);
  };
  const isBannerVisible = ():boolean => {
    return isVisible;
  };

  return (
    <ExceptionContext.Provider
      value={{ isVisible, title, message, setException, clearException, isBannerVisible }}
    >
      {children}
    </ExceptionContext.Provider>
  );
};

export const useException = (): ExceptionContextType => {
  const context = useContext(ExceptionContext);
  if (!context) {
    throw new Error("useException must be used within an ExceptionProvider");
  }
  return context;
};
